// extracted by mini-css-extract-plugin
module.exports = {"avatar-img":"avatar_avatar-img__170Bh","author-v":"avatar_author-v__2Xocb"};